import React, { useState } from "react";
import "./styles.scss";
import { ReactComponent as BackArrow } from "../../../public/icons/back_arrow.svg";
import PayPalLogo from "../../../public/icons/PayPal-Logo.png";
import { Link } from "react-router-dom";
import _ from "lodash";
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";

export default ({ user }) => {
  const [values, setValues] = useState([1, 5, 10, 20]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [otherValue, setOtherValue] = useState(null);
  const [customValue, setCustomValue] = useState(null);
  const [customAmountModalShow, setCustomAmountModalShow] = useState(false);
  const chooseCustomValue = () => {
    setOtherValue(customValue);
    setCustomAmountModalShow(false);
    setValues([...values, customValue]);
    setSelectedValue(customValue);
  };
  const handleOpen = () => setCustomAmountModalShow(true);
  const handleClose = () => setCustomAmountModalShow(false);
  return (
    <div id="tip-jar">
      <Link to={`/${user.slug}`}>
        <BackArrow className="my-2" />
      </Link>
      <h1 className="m-4">TipJar</h1>
      {user.artist_profile && user.artist_profile.paypal_me_tag ? (
        <div className="text-primary text-center w-75 mx-auto">
          <h2 className="text-uppercase mb-3">Support your artist!</h2>
          <p className="mb-5">100% of your tip goes to the artists to support them to create the music you liked!</p>
          <div className="options d-flex justify-content-between align-items-center mb-5">
            {values.map((val) => (
              <button
                onClick={() => setSelectedValue(val)}
                className={`btn btn-${val === selectedValue ? "primary" : "outline-primary"} rounded-circle`}
              >
                ${val}
              </button>
            ))}
            {_.isNull(otherValue) ? (
              <button onClick={handleOpen} className="btn btn-outline-primary rounded-circle">
                Other
              </button>
            ) : null}
          </div>
          <h3 className="text-left">Payment Method</h3>
          <div id="payment-methods" className="mb-5">
            <input type="radio" defaultChecked={true} id="paypal" className="mr-4" />
            <label htmlFor="paypal">
              <img src={PayPalLogo} alt="paypallogo" />
            </label>
          </div>
          <a
            href={`https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=${user.artist_profile.paypal_me_tag}&item_name=UNIFI+Music+TipJar&amount=${selectedValue}`}
            className="btn btn-lg btn-primary text-white"
            disabled={!selectedValue}
            target="_blank"
            rel="noopener noreferrer"
          >
            Send
          </a>
          <Modal className="custom-amount" show={customAmountModalShow} onHide={handleClose}>
            <ModalHeader closeButton onHide={handleClose} />
            <ModalBody>
              <div className="input-container">
                <input
                  type="number"
                  value={customValue}
                  onKeyDown={(e) => e.keyCode === 13 && chooseCustomValue()}
                  onChange={(e) => setCustomValue(e.target.value)}
                  placeholder="Enter custom amount"
                />
              </div>
              <button className="btn btn-primary btn-lg" disabled={!customValue} onClick={chooseCustomValue}>
                Done
              </button>
            </ModalBody>
          </Modal>
        </div>
      ) : (
        <div>You cannot tip this user</div>
      )}
    </div>
  );
};
